import {Component} from '@angular/core';

import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
    selector: 'app-health',
    imports: [
    FaIconComponent
],
    templateUrl: './health.component.html',
    styleUrls: ['./health.component.css']
})
export class HealthComponent {
}
